import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useAccount, useWalletClient } from "wagmi";
import { setModal } from "../redux/counterSlice";
import useGetAcceptTermSignature from "../services/useGetAcceptTermSignature";

export const AcceptTermsWrapper = ({ children }) => {
  const { isSuccess } = useWalletClient();
  const { address } = useAccount();
  const dispatch = useDispatch();
  const { data: acceptTerms } = useGetAcceptTermSignature(address);

  useEffect(() => {
    if (isSuccess) {
      if (acceptTerms == false) {
        dispatch(setModal({ key: "AcceptTermsModal" }));
      }
    }
  }, [isSuccess, address]);
  return <div>{children}</div>;
};
